import { render, staticRenderFns } from "./AdminDashboardTable.vue?vue&type=template&id=308fae68&scoped=true"
import script from "./AdminDashboardTable.vue?vue&type=script&lang=js"
export * from "./AdminDashboardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308fae68",
  null
  
)

export default component.exports